import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=6db54bc2&scoped=true"
import script from "./Warning.vue?vue&type=script&lang=ts"
export * from "./Warning.vue?vue&type=script&lang=ts"
import style0 from "./Warning.vue?vue&type=style&index=0&id=6db54bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db54bc2",
  null
  
)

export default component.exports